import {
    GenericSuspense,
} from "@bsm/component";
import { Outlet } from "react-router-dom";
import BarLoader from 'react-spinners/BarLoader';
import { NotificationDialog } from "@bsm/notification";
import { UserNavBar } from "./UserNavBar";

const UserLayout = () => {

    return (
        <>
            <div className="admin-layout flex w-full">
                <main className="w-full transition-all duration-1000 ease-in-out flex-1 flex flex-col !bg-body-background">
                    <UserNavBar />
                    <GenericSuspense
                        fallback={
                            <BarLoader className='main-spinner-bar-loader shadow-sm' width="100%" />
                        }
                    >
                        <div className="flex items-start justify-center w-full p-0 parent-layout">
                            <Outlet />
                        </div>
                    </GenericSuspense>
                </main>
            </div>

            <NotificationDialog />
        </>
    );
};

export default UserLayout;
